import { RecurringBillingSchedule } from "@scrile/api-provider/dist/api/RecurringBillingScheduleProvider";
import { isSubscriptionRecurringBillingScheduleContent } from "@scrile/api-provider/dist/api/SubscriptionProvider";

export { default } from "./SubscriptionItemView.vue";
export const selector = (item: RecurringBillingSchedule): boolean => {
  return isSubscriptionRecurringBillingScheduleContent(item.content);
};
